import axios from 'axios';

export const loc = window.location;
export const baseUrl = window._env_ && window._env_.REACT_APP_BASE_URL ? window._env_.REACT_APP_BASE_URL : process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : loc.origin;
export const apiUrl = () => {
  if (window._env_ && window._env_.REACT_APP_API_BASE_URL){    
    return window._env_.REACT_APP_API_BASE_URL;
  }
  return axios.get(window._env_.REACT_APP_CENTRAL_BASE_URL + 'd-retrieve')
  .then((response) => {    
    window._env_={'REACT_APP_API_BASE_URL': 'https://' + response.data.domain + '/api'};
    return  window._env_.REACT_APP_API_BASE_URL;
  });    
}
export const webUrl = process.env.REACT_APP_WEB_URL;
export const NAME_PREFIXES = [
  {
    key: "Mr",
    value: "Mr",
    text: "Mr"
  },
  {
    key: "Mrs",
    value: "Mrs",
    text: "Mrs"
  },
  {
    key: "Ms",
    value: "Ms",
    text: "Ms"
  },
  {
    key: "Miss",
    value: "Miss",
    text: "Miss"
  },
];
export const COUNTRIES = [
  {
    key: "USA",
    value: "USA",
    text: "United States of America"
  },
  {
    key: "CAN",
    value: "CAN",
    text: "Canada"
  }
];
export const ZONES = [
  {
    key: "AL",
    value: "AL",
    text: "Alabama",
    country: "USA"
  },
  {
    key: "AK",
    value: "AK",
    text: "Alaska",
    country: "USA"
  },
  {
    key: "AZ",
    value: "AZ",
    text: "Arizona",
    country: "USA"
  },
  {
    key: "AR",
    value: "AR",
    text: "Arkansas",
    country: "USA"
  },
  {
    key: "CA",
    value: "CA",
    text: "California",
    country: "USA"
  },
  {
    key: "CO",
    value: "CO",
    text: "Colorado",
    country: "USA"
  },
  {
    key: "CT",
    value: "CT",
    text: "Connecticut",
    country: "USA"
  },
  {
    key: "DE",
    value: "DE",
    text: "Delaware",
    country: "USA"
  },
  {
    key: "FL",
    value: "FL",
    text: "Florida",
    country: "USA"
  },
  {
    key: "GA",
    value: "GA",
    text: "Georgia",
    country: "USA"
  },
  {
    key: "HI",
    value: "HI",
    text: "Hawaii",
    country: "USA"
  },
  {
    key: "ID",
    value: "ID",
    text: "Idaho",
    country: "USA"
  },
  {
    key: "IL",
    value: "IL",
    text: "Illinois",
    country: "USA"
  },
  {
    key: "IN",
    value: "IN",
    text: "Indiana",
    country: "USA"
  },
  {
    key: "IA",
    value: "IA",
    text: "Iowa",
    country: "USA"
  },
  {
    key: "KS",
    value: "KS",
    text: "Kansas",
    country: "USA"
  },
  {
    key: "KY",
    value: "KY",
    text: "Kentucky",
    country: "USA"
  },
  {
    key: "LA",
    value: "LA",
    text: "Louisiana",
    country: "USA"
  },
  {
    key: "ME",
    value: "ME",
    text: "Maine",
    country: "USA"
  },
  {
    key: "MD",
    value: "MD",
    text: "Maryland",
    country: "USA"
  },
  {
    key: "MA",
    value: "MA",
    text: "Massachusetts",
    country: "USA"
  },
  {
    key: "MI",
    value: "MI",
    text: "Michigan",
    country: "USA"
  },
  {
    key: "MN",
    value: "MN",
    text: "Minnesota",
    country: "USA"
  },
  {
    key: "MS",
    value: "MS",
    text: "Mississippi",
    country: "USA"
  },
  {
    key: "MO",
    value: "MO",
    text: "Missouri",
    country: "USA"
  },
  {
    key: "MT",
    value: "MT",
    text: "Montana",
    country: "USA"
  },
  {
    key: "NE",
    value: "NE",
    text: "Nebraska",
    country: "USA"
  },
  {
    key: "NV",
    value: "NV",
    text: "Nevada",
    country: "USA"
  },
  {
    key: "NH",
    value: "NH",
    text: "New Hampshire",
    country: "USA"
  },
  {
    key: "NJ",
    value: "NJ",
    text: "New Jersey",
    country: "USA"
  },
  {
    key: "NM",
    value: "NM",
    text: "New Mexico",
    country: "USA"
  },
  {
    key: "NY",
    value: "NY",
    text: "New York",
    country: "USA"
  },
  {
    key: "NC",
    value: "NC",
    text: "North Carolina",
    country: "USA"
  },
  {
    key: "ND",
    value: "ND",
    text: "North Dakota",
    country: "USA"
  },
  {
    key: "OH",
    value: "OH",
    text: "Ohio",
    country: "USA"
  },
  {
    key: "OK",
    value: "OK",
    text: "Oklahoma",
    country: "USA"
  },
  {
    key: "OR",
    value: "OR",
    text: "Oregon",
    country: "USA"
  },
  {
    key: "PA",
    value: "PA",
    text: "Pennsylvania",
    country: "USA"
  },
  {
    key: "RI",
    value: "RI",
    text: "Rhode Island",
    country: "USA"
  },
  {
    key: "SC",
    value: "SC",
    text: "South Carolina",
    country: "USA"
  },
  {
    key: "SD",
    value: "SD",
    text: "South Dakota",
    country: "USA"
  },
  {
    key: "TN",
    value: "TN",
    text: "Tennessee",
    country: "USA"
  },
  {
    key: "TX",
    value: "TX",
    text: "Texas",
    country: "USA"
  },
  {
    key: "UT",
    value: "UT",
    text: "Utah",
    country: "USA"
  },
  {
    key: "VT",
    value: "VT",
    text: "Vermont",
    country: "USA"
  },
  {
    key: "VA",
    value: "VA",
    text: "Virginia",
    country: "USA"
  },
  {
    key: "WA",
    value: "WA",
    text: "Washington",
    country: "USA"
  },
  {
    key: "WV",
    value: "WV",
    text: "West Virginia",
    country: "USA"
  },
  {
    key: "WI",
    value: "WI",
    text: "Wisconsin",
    country: "USA"
  },
  {
    key: "WY",
    value: "WY",
    text: "Wyoming",
    country: "USA"
  },
  {
    key: "AB",
    value: "AB",
    text: "Alberta",
    country: "CAN"
  },
  {
    key: "BC",
    value: "BC",
    text: "British Columbia",
    country: "CAN"
  },
  {
    key: "MB",
    value: "MB",
    text: "Manitoba",
    country: "CAN"
  },
  {
    key: "NB",
    value: "NB",
    text: "New Brunswick",
    country: "CAN"
  },
  {
    key: "NL",
    value: "NL",
    text: "Newfoundland and Labrador",
    country: "CAN"
  },
  {
    key: "NS",
    value: "NS",
    text: "Nova Scotia",
    country: "CAN"
  },
  {
    key: "ON",
    value: "ON",
    text: "Ontario",
    country: "CAN"
  },
  {
    key: "PE",
    value: "PE",
    text: "Prince Edward Island",
    country: "CAN"
  },
  {
    key: "QC",
    value: "QC",
    text: "Quebec",
    country: "CAN"
  },
  {
    key: "SK",
    value: "SK",
    text: "Saskatchewan",
    country: "CAN"
  }
];
export const invertColor = (hex, bw) => {
  if(!hex){
    return "#FFFFFF";
  }
  if (hex.indexOf("#") === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error("Invalid HEX color.");
  }
  var r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    // http://stackoverflow.com/a/3943023/112731
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
  }
  // invert color components
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  // pad each with zeros and return
  return "#" + padZero(r) + padZero(g) + padZero(b);
};
export const padZero = (str, len) => {
  len = len || 2;
  var zeros = new Array(len).join("0");
  return (zeros + str).slice(-len);
};
export function formatInt(str) {
  let result = parseInt(str);
  return result.toLocaleString('en-US');
}
export function formatFloat(str, decimals = 0) {
  let result = parseFloat(str);
  return result.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}
export function formatCurrency(str, decimals = 0) {
  let result = parseFloat(str);
  // isInteger
  return result.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}
export function formatPercent(str, decimals = 0) {
  let result = parseFloat(str);
  // isInteger
  return result.toLocaleString('en-US', { style: 'percent', minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}
export function formatTime(time) {
  let parts = time.split(' ');
  let formatted = '';
  let ampm = '';
  if (parts[parts.length - 1].toUpperCase() === "AM" || parts[parts.length - 1].toUpperCase() === "PM") {
    // 12H time
    ampm = parts[parts.length - 1].toUpperCase();
    formatted = parts[parts.length - 2] + ' ' + ampm;
  } else {
    // 24H time
    // Previous logic
    time = parts[parts.length - 1];
    let H = time.substr(0, 2);
    let h = H % 12 || 12;
    ampm = (H < 12 || H === 24) ? " AM" : " PM";
    formatted = h + time.substr(2, 3) + ampm;
  }
  return formatted;
}